import * as React from "react";
const SvgShoppingCartCheckout = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={props.fill || "currentColor"}
      d="M7 22q-.824 0-1.412-.587A1.93 1.93 0 0 1 5 20q0-.824.588-1.413A1.93 1.93 0 0 1 7 18q.824 0 1.412.587Q9 19.176 9 20q0 .824-.588 1.413A1.93 1.93 0 0 1 7 22m10 0q-.825 0-1.412-.587A1.93 1.93 0 0 1 15 20q0-.824.588-1.413A1.93 1.93 0 0 1 17 18q.824 0 1.413.587Q19 19.176 19 20q0 .824-.587 1.413A1.93 1.93 0 0 1 17 22M3 4H2a.97.97 0 0 1-.712-.288A.97.97 0 0 1 1 3q0-.424.288-.712A.97.97 0 0 1 2 2h1.65q.275 0 .525.15t.375.425L8.525 11h7l3.625-6.5a.85.85 0 0 1 .35-.375Q19.725 4 20 4q.574 0 .863.487a.94.94 0 0 1 .012.988L17.3 11.95q-.275.5-.738.775A1.95 1.95 0 0 1 15.55 13H8.1L7 15h11q.424 0 .712.287.288.288.288.713 0 .424-.288.712A.97.97 0 0 1 18 17H7q-1.124 0-1.713-.975-.587-.975-.037-1.975L6.6 11.6zm9.175 3H9a.97.97 0 0 1-.713-.287A.97.97 0 0 1 8 6q0-.424.287-.713A.97.97 0 0 1 9 5h3.175l-.9-.9a.92.92 0 0 1-.287-.7Q11 3 11.3 2.7q.3-.275.7-.288t.7.288l2.6 2.6q.3.3.3.7t-.3.7l-2.6 2.6a.98.98 0 0 1-.687.287.93.93 0 0 1-.713-.287.95.95 0 0 1-.275-.7q0-.425.275-.7z"
    />
  </svg>
);
export default SvgShoppingCartCheckout;
